import React, { useState, useEffect, useCallback } from 'react';
import { FiLogIn, FiLogOut, FiClock, FiAlertTriangle } from 'react-icons/fi';
import api from '../utils/api';
import { useAuth } from '../contexts/AuthContext';
import { featureFlagEnabled } from '../config/modulos';

export default function Fichajes() {
  const { usuario, empresa } = useAuth();
  const esAdmin = usuario?.rol === 'admin' || usuario?.rol === 'superadmin';
  const fichajesPorObraActivos = featureFlagEnabled(empresa, 'fichajes_por_obra');
  const [dentro, setDentro] = useState(false);
  const [mis, setMis] = useState([]);
  const [todos, setTodos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [fichando, setFichando] = useState(false);

  const cargar = useCallback(async () => {
    setCargando(true);
    try {
      const [est, mios] = await Promise.all([api.get('/fichajes/estado'), api.get('/fichajes/mis')]);
      setDentro(est.data.dentro);
      setMis(mios.data);
      if (esAdmin) { const t = await api.get('/fichajes'); setTodos(t.data); }
    } catch { /* noop */ } finally { setCargando(false); }
  }, [esAdmin]);

  useEffect(() => { cargar(); }, [cargar]);

  const fichar = async () => {
    setFichando(true);
    try { await api.post('/fichajes/fichar'); await cargar(); }
    catch (err) { alert(err.response?.data?.error || 'Error al fichar'); }
    finally { setFichando(false); }
  };

  const fmt = (d) => new Date(d).toLocaleString('es-ES');
  const dur = (m) => (m == null ? '—' : `${Math.floor(m / 60)}h ${m % 60}m`);
  const nombre = (u) => (typeof u === 'object' && u ? `${u.nombre} ${u.apellidos || ''}`.trim() : '—');

  return (
    <div className="page">
      <div className="page-head">
        <div><h1 className="page-title">Fichajes</h1><p className="page-subtitle">Control de entrada y salida</p></div>
      </div>

      {!fichajesPorObraActivos && (
        <div className="alert-warning"><FiAlertTriangle /> El control de fichajes por obra está desactivado para esta empresa; el fichaje básico sigue disponible.</div>
      )}

      <div className="fichar-panel">
        <div className={`estado-pill ${dentro ? 'dentro' : 'fuera'}`}>
          <FiClock /> {dentro ? 'Actualmente dentro' : 'Actualmente fuera'}
        </div>
        <button className={`btn btn-lg ${dentro ? 'btn-danger' : 'btn-primary'}`} onClick={fichar} disabled={fichando}>
          {dentro ? <><FiLogOut /> Fichar salida</> : <><FiLogIn /> Fichar entrada</>}
        </button>
      </div>

      <h3 className="permisos-titulo">Mis fichajes</h3>
      {cargando ? <p className="empty">Cargando…</p> : mis.length === 0 ? <p className="empty">Sin fichajes.</p> : (
        <div className="table-wrap">
          <table className="data-table">
            <thead><tr><th>Tipo</th><th>Fecha y hora</th><th>Duración</th></tr></thead>
            <tbody>
              {mis.map((f) => (
                <tr key={f._id}>
                  <td data-label="Tipo"><span className={`badge ${f.tipo === 'entrada' ? 'badge-ok' : 'badge-info'}`}>{f.tipo}</span></td>
                  <td data-label="Fecha">{fmt(f.fecha)}</td>
                  <td data-label="Duración">{f.tipo === 'salida' ? dur(f.duracion) : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {esAdmin && (
        <>
          <h3 className="permisos-titulo">Fichajes del equipo</h3>
          {todos.length === 0 ? <p className="empty">Sin registros.</p> : (
            <div className="table-wrap">
              <table className="data-table">
                <thead><tr><th>Empleado</th><th>Tipo</th><th>Fecha y hora</th><th>Duración</th></tr></thead>
                <tbody>
                  {todos.map((f) => (
                    <tr key={f._id}>
                      <td data-label="Empleado">{nombre(f.usuarioId)}</td>
                      <td data-label="Tipo"><span className={`badge ${f.tipo === 'entrada' ? 'badge-ok' : 'badge-info'}`}>{f.tipo}</span></td>
                      <td data-label="Fecha">{fmt(f.fecha)}</td>
                      <td data-label="Duración">{f.tipo === 'salida' ? dur(f.duracion) : '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
}
